export default "__VITE_ASSET__CcNmGRQy__"